import { isMobile } from '@/utils';
import day from 'dayjs';
import Tracker from './tracker';

class CartTracker extends Tracker {
  /**
   *
   * @description 购物车页公共埋点
   * @param {string} catrgory 加在cart_page后的类别
   * @param {string} action 事件操作
   * @param {object} cartItem 购物车item
   * @param {object} cartItem 购物车item
   *
   */
  cartPage = ({ action, cartItem, label, category }) => {
    let value = 1;
    try {
      switch (action) {
        case 'quantity_minus':
        case 'quantity_input':
        case 'item_remove':
        case 'item_deselected':
        case 'item_selected':
          const { url_key, commodity } = cartItem;
          label = `${url_key} + ${commodity?.info?.name}(${commodity.id})`;
          break;
        case 'continue_shopping_click':
        case 'check_out_click':
        case 'recommend_page_change':
        case 'recommend_add_to_cart':
        case 'recommend_stock_notice':
        default:
          break;
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page${category ? '_' + category : ''}`,
        action,
        label: label ?? '',
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 购物车页item绑定服务埋点
   * @param {string} action 事件操作
   * @param {object} cartItem 购物车item
   * @param {object} serviceItem 绑定服务item
   *
   */
  cartPageBindService = ({ action, cartItem, serviceItem }) => {
    let label = '';
    let value = '';
    try {
      switch (action) {
        case 'add_to_cart':
        case 'remove':
        case 'learn_more_enter':
        case 'learn_more_close':
        case 'learn_more_add_to_cart':
          const { url_key, commodity } = cartItem;
          label = `${url_key}(${commodity.id}) + ${serviceItem.name}(${serviceItem.id})`;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page_bind_service`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 购物车页点击结算绑定服务加购模态框埋点
   * @param {string} action 事件操作
   * @param {object} serviceItem 绑定服务item
   *
   */
  cartPageAddBindServicePopUp = ({ action, serviceItem }) => {
    let label = '';
    let value = '';
    try {
      switch (action) {
        case 'item_selected':
        case 'item_deselected':
          label = `${serviceItem.product_url_key} + ${serviceItem.name}(${serviceItem.id})`;
          break;
        case 'enter':
        case 'no_thank_you':
        case 'add_to_cart':
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page_bind_service_popup`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 购物车返修库存销售弹窗曝光
   * @param {string} action 事件操作
   * @param {object} serviceItem 绑定服务item
   *
   */
  cartPageSpecialSalesStockModal = ({ action }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page_SpecialSalesStockModal`,
        action,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 购物车行业房产产品 权益弹窗曝光
   * @param {string} action 事件操作
   *
   */
  cartPageVirtualTourkitModal = ({ action }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page_enterprise_popup`,
        action,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 购物车含电弹窗曝光
   * @param {string} action 事件操作
   * @param {string} label 事件标签
   *
   */
  cartPageModal = ({ action, label, isMobile, lang }) => {
    try {
      let time = day().format('YYYY-MM-DD HH:mm:ss');
      this.commonTracker({
        category: `${isMobile ? 'mobile' : 'pc'}_cart_page_modal`,
        action,
        label: label ?? `${lang}_${time}`,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description T恤赠品模块
   * @date 2023/05/17 12:01:42
   */
  extraTShirtGift = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cart_page_tshirt`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new CartTracker();
export default T;
